<template>
  <div class="col-md-6 col-sm-12 align-left footer-bottom">
    <p>
      Copyleft&nbsp;
      <router-link class="no-link copyleft" to="/login">&copy;</router-link>
      &nbsp;<a href="https://foobar.beer">Jakub Stonavský</a>&nbsp;2022&nbsp;
      All rights <a href="http://wtfpl.net" title="WTFPL">ignored</a>.
      <api-check></api-check>
    </p>
  </div>
</template>

<script>
import ApiCheck from '@/components/utils/ApiCheck'
export default {
  components: {
    ApiCheck
  }
}
</script>



// WEBPACK FOOTER //
// FooterCopyleft.vue?6501d62c